import angular from 'angular';

angular
  .module('cxSettings')
  .controller('InvoiceTextDialogCtrl', [
    '$element',
    '$scope',
    'resourceFactorySvc',
    'flySvc',
    'close',
    'invoiceText',
    'dataCache',
    '$http',
    'ModalService',
    'appUrls',
    invoiceTextDialogCtrl,
  ]);

function invoiceTextDialogCtrl(
  $element,
  $scope,
  resourceFactorySvc,
  flySvc,
  close,
  invoiceText,
  dataCache,
  $http,
  ModalService,
  appUrls,
) {
  var vm = this;
  vm.showValidation = false;
  vm.translation = {};
  vm.languages = ['en', 'nl', 'fr'];
  vm.hasDraftInvoices = false;
  vm.invoiceText = angular.extend(
    {
      name: '',
      type: null,
      languages: {
        nl: '',
        fr: '',
        en: '',
      },
    },
    invoiceText,
  );

  dataCache.ready().then(function() {
    vm.languages = dataCache.getArray('language').map(x => x.code);
  });

  vm.updateName = function(value) {
    vm.invoiceText.name = value;
  };

  vm.save = function() {
    if ($scope.form.$invalid) return;
    vm.saving = true;
    resourceFactorySvc.get('invoiceText')[vm.invoiceText.id ? 'update' : 'save'](
      {},
      vm.invoiceText,
      function(result) {
        vm.saving = false;
        if (vm.translation && vm.translation.save && result.id) {
          vm.translation.save(result.id).then(function() {
            $element.modal('hide');
            close(result, 500);
          });
        } else {
          $element.modal('hide');
          close(result, 500);
        }
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };

  vm.showPlaceholders = function() {
    if (!vm.placeholders) {
      $http.get(appUrls.api + '/api/invoicetext/placeholders').then(
        function(result) {
          vm.placeholders = result.data;
          vm.showPlaceholders();
        },
        function(error) {
          flySvc.error(error.code, error.parameters);
        },
      );
      return;
    }

    ModalService.showModal({
      template: require('./placeholderDialog.html'),
      controller: 'PlaceholderDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        placeholders: vm.placeholders,
        taskParameterPlaceholders: [],
        context: 'invoicetext',
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };

  if (invoiceText && invoiceText.id) {
    $http.get(`${appUrls.api}/api/invoicetext/DraftCount/${invoiceText.id}`).then(({ data }) => {
      if (data && data.count > 0) {
        vm.hasDraftInvoices = true;
        vm.invoiceText.regenerateInDraftInvoices = true;
      }
    });
  }
}
